module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "mu-th",
    on: {
      "mouseenter": _vm.showTooltip,
      "mouseleave": _vm.hideTooltip
    }
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "mu-th-wrapper"
  }, [_vm._t("default"), _vm._v(" "), (_vm.tooltip) ? _c('tooltip', {
    attrs: {
      "trigger": _vm.tooltipTrigger,
      "verticalPosition": _vm.verticalPosition,
      "horizontalPosition": _vm.horizontalPosition,
      "show": _vm.tooltipShown,
      "label": _vm.tooltip,
      "touch": _vm.touch
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1842baeb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/table/th.vue
// module id = 421
// module chunks = 1